/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActionRequestRead } from '../../models/action-request-read';
import { ResolveActionRequest } from '../../models/resolve-action-request';

export interface ResolveActionRequestApiV1ActionRequestsRequestIdResolvePost$Params {
  request_id: string;
      body: ResolveActionRequest
}

export function resolveActionRequestApiV1ActionRequestsRequestIdResolvePost(http: HttpClient, rootUrl: string, params: ResolveActionRequestApiV1ActionRequestsRequestIdResolvePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ActionRequestRead>> {
  const rb = new RequestBuilder(rootUrl, resolveActionRequestApiV1ActionRequestsRequestIdResolvePost.PATH, 'post');
  if (params) {
    rb.path('request_id', params.request_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ActionRequestRead>;
    })
  );
}

resolveActionRequestApiV1ActionRequestsRequestIdResolvePost.PATH = '/api/v1/action-requests/{request_id}/resolve';
